/* ==========================================================================
   SearcherFli > Client > Submit > Url > CrossSelling
   ========================================================================== */

function buildRoomData(instance) {
    const { passengers } = instance.store.select('data');
    const { adults, children, babies } = passengers;

    return { PDadultos: adults, PDninos: children, PDbebes: babies, PDhabMultiple: 0 };
}

const formatDate = date =>
    [
        `${date
            .getDate()
            .toString()
            .padStart(2, '0')}`,
        `${(date.getMonth() + 1).toString().padStart(2, '0')}`,
        `${date.getFullYear()}`
    ].join('/');

function buildFormBody(instance) {
    const { calendar, origin, destination } = instance.store.select('data');
    const [startDate, endDate] = calendar;

    const body = {
        ciaAerea: '',
        origenSV: origin.value,
        destinoSV: destination.value,
        residente: '',
        SoloIdaSV: '',
        fechaIdaSV: formatDate(startDate),
        fechaVueltaSV: formatDate(endDate),
        MasHotel: '1',
        MasCoche: '',
        tipo: '1',
        incluirTrenes: '',
        proveedor: '',
        codigoHotel: '',
        vueloslowcost: '1',
        ...buildRoomData(instance)
    };

    const bodyEncoded = new URLSearchParams();
    Object.entries(body).forEach(([key, value]) => bodyEncoded.set(key, value));
    return bodyEncoded;
}

module.exports = {
    buildFormBody
};
